import React from 'react';

export default function ReChart({ chtData, params, spName, type, myWidth, myHeight }) {
  return (
    <div style={{padding:'5px', flex:1, height:'100%' }}>
      WORKKS
    </div>
  );
}
